import { useEffect, useState } from 'react';
import type { StickyZoneStyle, StickyZoneTitlePosition, StickyZoneShape } from '../../domain';
import { StickyZoneMenuContent } from './StickyZoneMenuContent';
import { StickyZoneMenuId } from './StickyZoneMenuId';
import { Point } from '@view-model/models/common/basic';
import { MenuContainer } from '@model-framework/menu';
import { MenuSize } from '@view-model/models/sticky/ui';
import type { ThemeColor } from '@view-model/models/common/color';
import type { TextAlign } from '@view-model/models/common/text-align';
import type { FontSize } from '@model-framework/text';

type Props = {
  currentStyle: StickyZoneStyle;
  offset: { x: number; y: number };
  textEditing: boolean;
  url: string | null;
  onFontSizeSelected(fontSize: FontSize): void;
  onThemeColorSelected(themeColor: ThemeColor): void;
  onTextAlignSelected(textAlign: TextAlign): void;
  onZoneShapeSelected(newShape: StickyZoneShape): void;
  onZoneTitlePositionSelected(titlePosition: StickyZoneTitlePosition): void;
  onToggleZoneDescription(): void;
  onDeleteZone(): void;
  onGroupSelectedZone(): void;
  onSaveHyperLink(url: string | null): void;
  onZoneToView(): void;
};

export const StickyZoneMenu: React.FC<Props> = ({
  currentStyle,
  offset,
  textEditing,
  url,
  onFontSizeSelected,
  onThemeColorSelected,
  onTextAlignSelected,
  onZoneShapeSelected,
  onZoneTitlePositionSelected,
  onToggleZoneDescription,
  onDeleteZone,
  onGroupSelectedZone,
  onSaveHyperLink,
  onZoneToView,
}: Props) => {
  const [openedMenu, setOpenedMenu] = useState<StickyZoneMenuId | null>(null);

  useEffect(() => {
    if (textEditing) {
      setOpenedMenu(null);
    }
  }, [textEditing]);

  const availableMenuIds = Object.values(StickyZoneMenuId);

  const menuSize = { width: MenuSize * availableMenuIds.length, height: MenuSize };
  const position = new Point(offset.x, offset.y);

  return (
    <MenuContainer position={position} size={menuSize} positionOrigin="left-bottom">
      {availableMenuIds.map((menuId, i) => (
        <g key={menuId} transform={`translate(${MenuSize * i}, 0)`}>
          <StickyZoneMenuContent
            menuId={menuId}
            menuSize={MenuSize}
            currentStyle={currentStyle}
            isOpen={openedMenu === menuId}
            url={url}
            onMenuOpen={(menuId) => setOpenedMenu(menuId)}
            onMenuClose={() => setOpenedMenu(null)}
            onFontSizeSelected={onFontSizeSelected}
            onToggleZoneDescription={onToggleZoneDescription}
            onZoneShapeSelected={onZoneShapeSelected}
            onZoneTitlePositionSelected={onZoneTitlePositionSelected}
            onThemeColorSelected={onThemeColorSelected}
            onTextAlignSelected={onTextAlignSelected}
            onSaveHyperLink={onSaveHyperLink}
            onDeleteZone={onDeleteZone}
            onGroupSelectedZone={onGroupSelectedZone}
            onZoneToView={onZoneToView}
          />
        </g>
      ))}
    </MenuContainer>
  );
};
